import { render, staticRenderFns } from "./clientCardLarge.vue?vue&type=template&id=0e430a8a"
import script from "./clientCardLarge.vue?vue&type=script&lang=js"
export * from "./clientCardLarge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports